import React from 'react';
import { DropdownProvider } from './DropdownContext';
import Select from './Select';
import ButtonSelect from './ButtonSelect';
import { List, ClearSelect, RadioItems, Search } from './DropdownComponents';

const Dropdown = props => {
  return (
    <DropdownProvider {...props}>
      <div
        className='form-dropdown dropdown-single-select'
        style={props.styleCss}
      >
        {props.children}
      </div>
    </DropdownProvider>
  );
};

Dropdown.Select = Select;
Dropdown.ButtonSelect = ButtonSelect;
Dropdown.List = List;
Dropdown.ClearSelect = ClearSelect;
Dropdown.RadioItems = RadioItems;
Dropdown.Search = Search;

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/Dropdown.jsx